import React from 'react';
import ImageGallerproduction from '../components/ImageGallerproduction';
import IRCTVDonationCard2 from "./IRCTVDonationCard2.jsx";


const IRCPRODUCTION = () => {
    return (
        <>
            <div className="about-us-container">
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>OUR ACTIVITIES</h2>
                        <p>
                            All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities
                        </p>
                    </div>
                    <ImageGallerproduction />
                    {/* Women Empowerment Programs */}
                    <div className="activity-card">
                        
                        <div className="activity-header">
                            <h3>PRODUCTION</h3>
                        </div>
                        <div className="activity-content">
                            <p>
                                IRC has its own production studio where lectures of various speakers of IRC and other guest speakers are recorded, edited and aired on satellite channels, cable TVs & uploaded on various social media platforms on the internet.
                            </p>
                        </div>
                        <IRCTVDonationCard2
                            title="PRODUCTION"
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: SPONSER A SHORT REEL"

                            description2="Donate Us continue providing quality content and services to our community."
                            baseAmount={500}        // Pass as number
                            baseAmount2={15000}     // Pass as number
                            purpose2="Cause: SPONSER A COMPLETE LECTURE"
                        />
                    </div>
                </section>
            </div>
        </>
    );
};

export default IRCPRODUCTION;
